import { requiredField } from "helpers/validators";
import React from "react";

const ExpressBid = ({ config, renderField, renderCheckbox, isExpressBidValue, onChange, expressBidSettings }) => {
    const { isExpressBid, averageSpeed, workHours, dayStart } = config;
    return (
        <>
            {renderCheckbox({ ...isExpressBid, fieldWrapper: "col-sm-8 col-md-5" })}
            {isExpressBidValue && (
                <>
                    {renderField({
                        ...averageSpeed,
                        onChange,
                        value: expressBidSettings[averageSpeed.inputProps.name],
                        fieldWrapper: "col-sm-8 col-md-5",
                        validators: [requiredField],
                    })}
                    {renderField({
                        ...dayStart,
                        onChange,
                        value: expressBidSettings[dayStart.inputProps.name],
                        fieldWrapper: "col-sm-8 col-md-5",
                        validators: [requiredField],
                    })}
                    {renderField({
                        ...workHours,
                        onChange,
                        value: expressBidSettings[workHours.inputProps.name],
                        fieldWrapper: "col-sm-8 col-md-5",
                        validators: [requiredField],
                    })}
                </>
            )}
        </>
    );
};

export default ExpressBid;
